import React, { useEffect, useState, useMemo } from 'react';
import { Form } from 'react-final-form';
import createDecorator from 'final-form-focus';
import { useTranslation } from 'react-i18next';
// import analytics from '@common/utils/analytics';
import api from '@common/utils/api';
import formutils from '@common/utils/formutils';
import DwFormField from '@common/ui/formfield/DwFormField';
import DwFormFieldPhoneWithPrefix from '@common/ui/formfield/DwFormFieldPhoneWithPrefix';
import { BAA } from '@utils/constants';
import ErrorBox from '@components/common/ErrorBox';
import BookAnAppointmentReasonMessage from '@stone/components/appointments/BookAnAppointmentReasonMessage';
import BookAnAppointmentDateSelection from '@stone/components/appointments/BookAnAppointmentDateSelection';
import ProductBoutiqueSelected from './ProductBoutiqueSelected';
import Button from '@stone/ui/button/Button';
const focusOnError = createDecorator();
const ProductBoutiqueReserve = (props) => {
    var _a;
    const { product, currentStore, initialValues, currentColor, currentSize, formdef, setDays, customer } = props;
    const { t } = useTranslation();
    const loggedIn = useMemo(() => {
        return window.loggedin;
    }, [window.loggedin]);
    const [collections, setCollections] = useState([]);
    const [errors, setErrors] = useState([]);
    const [hasAppointmentSlots, setHasAppointmentSlots] = useState(false);
    const [daySlots, setDaySlots] = useState({});
    useEffect(() => {
        // if (currentStore) {
        //   analytics.reserveInBoutiqueOverlay(product.id, currentSize.id);
        // }
        var _a;
        if (currentStore && ((_a = currentStore === null || currentStore === void 0 ? void 0 : currentStore.storeServices) === null || _a === void 0 ? void 0 : _a.bookAnAppointment)) {
            api.bookAnAppointmentSlots(currentStore === null || currentStore === void 0 ? void 0 : currentStore.ID, undefined, true).then((data) => {
                setDaySlots(data.days);
                setDays(data.days);
                setHasAppointmentSlots(Object.keys(data.days).length > 0);
            });
            api.bookAnAppointmentCollections(currentStore === null || currentStore === void 0 ? void 0 : currentStore.ID).then((data) => {
                setCollections(data);
            });
        }
        else {
            setDaySlots({});
            setDays({});
        }
    }, [currentStore]);
    const prefillValues = (values) => {
        values.productid = `${currentColor.productId}${currentSize.id}`;
        values.storeid = currentStore.ID;
    };
    const validate = async (values) => {
        if (loggedIn) {
            values.privacyFlag = true;
        }
        prefillValues(values);
        return await formutils.validateForm(values, formdef, 'reserve');
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        return await api
            .reserveInBoutique(values, formdef)
            .then((data) => {
            var _a, _b, _c;
            let errors = {};
            if (!data || data.error || ((_a = data.error) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setErrors(((_b = data.error) === null || _b === void 0 ? void 0 : _b.length) > 0 ? data.error : data.serverErrors.slice(0, 1));
                console.error(((_c = data.error) === null || _c === void 0 ? void 0 : _c.length) > 0 ? data.error : data.serverErrors);
                return;
            }
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            props.onSubmit(data, values);
        })
            .catch((e) => console.error(e));
    };
    const toogleChecked = (e) => {
        const checked = e.currentTarget.checked;
        if (!checked) {
            document.querySelector('.wrapper-bookanappointment').classList.add('d-none');
        }
        else {
            document.querySelector('.wrapper-bookanappointment').classList.remove('d-none');
        }
    };
    return (React.createElement("div", null,
        React.createElement(ProductBoutiqueSelected, { store: currentStore, onArrowBack: () => props.onStoreReset() }),
        React.createElement("hr", { className: "divider divider--xsmall" }),
        React.createElement("div", { className: "product-reserve__detail__form" },
            React.createElement(Form, { initialValues: initialValues, onSubmit: onSubmit, validate: validate, decorators: [focusOnError], mutators: {
                    global: formutils.globalMutator,
                    resetHours: (args, state, utils) => {
                        utils.changeValue(state, 'hour', () => null);
                    },
                }, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                    React.createElement("fieldset", { className: "fieldset--plain" },
                        React.createElement("div", { className: "ReserveForm" },
                            React.createElement("div", { className: "wrapper-info" },
                                React.createElement("div", { className: "row" },
                                    React.createElement("span", { className: "col-24 col-lg-12 reserve-info-title" }, t('profile.namesurname')),
                                    React.createElement("span", { className: "col-24 col-lg-12" },
                                        customer.firstName,
                                        " ",
                                        customer.lastName)),
                                React.createElement("div", { className: "row" },
                                    React.createElement("span", { className: "col-24 col-lg-12 reserve-info-title" }, t('profile.email')),
                                    React.createElement("span", { className: "col-24 col-lg-12" }, customer.email)),
                                customer.phone && (React.createElement("div", { className: "row" },
                                    React.createElement("span", { className: "col-24 col-lg-12 reserve-info-title" }, t('profile.phonenumber')),
                                    React.createElement("span", { className: "col-24 col-lg-12" },
                                        customer.phonePrefix,
                                        " ",
                                        customer.phone))),
                                !customer.phone && React.createElement(DwFormFieldPhoneWithPrefix, { def: formdef, uniqueLabel: t('profile.phonenumber') })),
                            React.createElement("div", { className: "row mt-24" },
                                React.createElement("div", { className: "col-24" },
                                    React.createElement(DwFormField, { def: formdef, name: "message", className: "blockview mt-16", type: "textarea" }))),
                            React.createElement(DwFormField, { def: formdef, name: "applicationorigin", value: values.applicationorigin, hiddenLabel: true, className: "visually-hidden" }),
                            hasAppointmentSlots && (React.createElement(React.Fragment, null,
                                React.createElement("p", { className: "py-4" }, t('bookanappointment.text')),
                                React.createElement("div", { className: "checkbox appount-flag" },
                                    React.createElement("div", { className: "checkbox__field" },
                                        React.createElement("input", { type: "checkbox", id: "bookanappointment", defaultChecked: false, onChange: (e) => {
                                                toogleChecked(e);
                                                form.mutators.global({ bookanappointment: e.currentTarget.checked });
                                            } }),
                                        React.createElement("label", { htmlFor: "bookanappointment" }, t('bookanappointment.checkbox')))),
                                React.createElement("div", { className: "wrapper-bookanappointment d-none" },
                                    React.createElement(BookAnAppointmentDateSelection, { formdef: formdef, days: daySlots, values: values, form: form }),
                                    React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col-24" },
                                            React.createElement(DwFormField, { def: formdef, name: "reason", type: "select" })),
                                        values.reason == BAA.REASONS.DISCOVERCOLLECTION && (collections === null || collections === void 0 ? void 0 : collections.length) > 0 && (React.createElement("div", { className: "col-24" },
                                            React.createElement(DwFormField, { def: formdef, name: "collectionCode", type: "select", options: [{ value: '', label: t('label.select') }].concat(collections) || [] })))),
                                    React.createElement(BookAnAppointmentReasonMessage, { formdef: formdef, values: values })))))),
                    React.createElement("div", { className: "product-reserve__detail__form__submit" },
                        React.createElement(Button, { type: "submit", className: "full", disabled: submitting, cls: ['button--primary'] }, t('button.reserveitem'))))) }),
            React.createElement(ErrorBox, { errors: errors }),
            React.createElement("p", { className: "product-reserve__detail__form__note" },
                React.createElement("small", { className: "note", dangerouslySetInnerHTML: { __html: t('notifyme.termsandconditions', { 0: (_a = document.getElementById('hidden-cookieurl')) === null || _a === void 0 ? void 0 : _a.href }) } })))));
};
export default ProductBoutiqueReserve;
